import { createContext, useContext, useReducer, useMemo } from 'react';
import { gameReducer, initialState } from './gameReducer';

const GameStateContext = createContext();
const GameDispatchContext = createContext();

export function GameProvider({ children }) {
  const [state, dispatch] = useReducer(gameReducer, initialState);

  const stateValue = useMemo(() => state, [state]);

  return (
    <GameStateContext.Provider value={stateValue}>
      <GameDispatchContext.Provider value={dispatch}>
        {children}
      </GameDispatchContext.Provider>
    </GameStateContext.Provider>
  );
}

export function useGameState() {
  const ctx = useContext(GameStateContext);
  if (ctx === undefined) throw new Error('useGameState must be used within GameProvider');
  return ctx;
}

export function useGameDispatch() {
  const ctx = useContext(GameDispatchContext);
  if (ctx === undefined) throw new Error('useGameDispatch must be used within GameProvider');
  return ctx;
}

// Convenience: both state and dispatch
export function useGame() {
  return { state: useGameState(), dispatch: useGameDispatch() };
}
